import { Component, Input } from '@angular/core';

@Component({
	selector: 'lomas-icon',
	templateUrl: 'icon.component.html',
	styleUrls: ['./icon.component.scss']
})
export class IconComponent {
	@Input() name: string;
}